module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/FilterOpen.2036df49.svg";